import { AutogenLayoutSegAllocDetailTable } from "./autogen/AutogenLayoutSegAllocDetailTable";

export enum AllocType {
    TRACTOR = "T",
    DRIVER = "D",
    ORDERMOVE = "M",
    SETTLEMENTPAYEE = "P",
    OFFICEPAYEE = "F",
    DEDFIXEDCHARGES = "B",
    TRAILERWASH = "W",
    MISCBILLING = "Z"
}

export class SegAllocDetailTable extends AutogenLayoutSegAllocDetailTable {
    private _allocType: AllocType

    textboxSegAllocCodeBeforeLookupModelSearch(event) {
        if (this._allocType == null) return;
        event.filter.alloc_type = this._allocType;
    }

    set allocType (allocType: AllocType) {
        this._allocType = allocType;
    }
}
